import { Injectable } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class Globals {
    showAdministration: boolean = false;
    showUser: boolean = false;
    showRole: boolean = false;
    showDashboardImage: boolean = false;
    showTenant: boolean = false;
    showSupport: boolean = false;
    showApplicationConfiguration: boolean = false;

    title: string = "SEAL";

    modules = ['MCI', 'TRG'];
    currentModule = 'MCI';

    year: number = new Date().getFullYear();

    constructor(
        private snackBar: MatSnackBar,
    ) {
    }

    setTitle(_title: string): void {
        this.title = _title;
    }

    setModule(_module: string): void {
        this.currentModule = _module;
    }

}

